import { atom } from "jotai";

import { DiningBookingWizard } from "../../../types";
import {
  DiningBookingKnownPeopleAtom,
  DiningBookingOwnerMemberAtom,
  DiningBookingWizardCurrentStepAtom,
  DiningBookingWizardDataAtom,
  DiningBookingWizardListOfStepsAtom,
} from "../../stores";

type InitializeDiningWizardStateAtomPayload = {
  initialDiningBookingWizardData: DiningBookingWizard.DiningBookingWizardData;
  knownPeople?: DiningBookingWizard.DiningBookingKnownPerson[];
  ownerMember?: DiningBookingWizard.DiningBookingKnownPerson | null;
};

export const initializeDiningWizardStateAtom = atom(
  null,
  (get, set, payload: InitializeDiningWizardStateAtomPayload) => {
    set(DiningBookingWizardDataAtom, payload.initialDiningBookingWizardData);
    set(DiningBookingWizardCurrentStepAtom, "DiningWizardDetailStep");

    const requiredSteps: DiningBookingWizard.DiningBookingWizardStep[] =
      payload.initialDiningBookingWizardData.partySize > 1
        ? ["DiningWizardDetailStep", "DiningAddKnownPeopleStep"]
        : ["DiningWizardDetailStep"];
    set(DiningBookingWizardListOfStepsAtom, requiredSteps);

    set(DiningBookingKnownPeopleAtom, payload.knownPeople ?? []);
    set(DiningBookingOwnerMemberAtom, payload.ownerMember ?? null);
  }
);
